/********************************
**** Ahrefs Web Analytics, consent-gated
****
**** Loads https://analytics.ahrefs.com/analytics.js only when the visitor
**** accepted every category of the Shopify cookie banner.
**** The Ahrefs key is read from the data-ahrefs-key attribute of this script tag.
****
**** - No choice yet / Decline / partial acceptance -> not loaded
**** - Accept all -> loaded right away, no reload needed
**** - Returning visitor who already accepted -> loaded on page load
****
**** sale_of_data counts as accepted unless explicitly refused ('no'),
**** because it is empty on stores where the category does not apply (EU, CA).
*********************************/

;(function () {
	var currentScript = document.currentScript
	var ahrefsKey = currentScript && currentScript.getAttribute('data-ahrefs-key')
	if (!ahrefsKey) return

	var loaded = false

	function allAccepted() {
		var cp = window.Shopify && window.Shopify.customerPrivacy
		if (!cp || typeof cp.currentVisitorConsent !== 'function') return false
		var c = cp.currentVisitorConsent() || {}
		return c.analytics === 'yes' && c.marketing === 'yes' && c.preferences === 'yes' && c.sale_of_data !== 'no'
	}

	function loadAhrefs() {
		if (loaded || !allAccepted()) return
		loaded = true
		var s = document.createElement('script')
		s.src = 'https://analytics.ahrefs.com/analytics.js'
		s.setAttribute('data-key', ahrefsKey)
		s.async = true
		document.head.appendChild(s)
	}

	// Banner interaction (Accept / Decline / Manage preferences)
	document.addEventListener('visitorConsentCollected', loadAhrefs)

	// Returning visitor: consent already stored
	function init(attempt) {
		if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
			window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
				if (!error) loadAhrefs()
			})
			return
		}
		if (attempt < 50) {
			setTimeout(function () {
				init(attempt + 1)
			}, 100)
		}
	}

	init(0)
})()
